module.exports = __webpack_public_path__ + "static/3A841E_3_0-f10b5e8d90a9b333a1d933cc711a5c9f.woff";